import { useState } from "react";
import { Dropdown } from "flowbite-react";
import { useTranslation } from "react-i18next";
import { languagesData } from "@/redux/setting/settingSlice";
import { FaCaretDown } from "react-icons/fa";
import { setLang } from "@/utils/localStorage";
import { twMerge } from "tailwind-merge";

const LocaleDropdown = () => {
  const { i18n } = useTranslation();

  const handleLangName = (lang: string) => {
    const languageNames: { [key: string]: string } = {
      en: "English",
      zh_HK: "繁體中文",
      zh_CN: "简体中文",
      ar: "العربية",
      es: "Español",
      fr: "Français",
      pt: "Português",
    };
    return languageNames[lang] || languageNames["en"];
  };
  const [langName, setLangName] = useState<string>(handleLangName(i18n.language));

  const handleChangeLanguage = (name: string, lang: string) => {
    setLangName(name);
    i18n.changeLanguage(lang);
    setLang(lang);
  };

  const triggerButton = () => {
    return (
      <div
        className={twMerge(
          `hover-scale-sm flex h-10 w-[110px] min-w-max cursor-pointer 
          items-center justify-center gap-1.5 rounded-[6px] border
          border-primary bg-primary p-2
          `
        )}
      >
        <p className="text-sm font-medium leading-normal text-white">{langName}</p>
        <FaCaretDown className="h-4 w-4 text-white" />
      </div>
    );
  };

  return (
    <div>
      <Dropdown
        label="Dropdown button"
        dismissOnClick={true}
        renderTrigger={() => triggerButton()}
        className="text-wite z-20 w-[110px] min-w-max rounded-md border border-primary bg-primary px-2 pb-2 shadow-lg focus:outline-none"
      >
        {languagesData.map((lang) => {
          return (
            <Dropdown.Item
              className={
                "hover:bg-secondary-light hover-bg-primary mt-2 flex justify-center py-1 text-sm font-medium text-white"
              }
              key={lang.id}
              onClick={() => handleChangeLanguage(lang.name, lang.lang)}
            >
              {lang.name}
            </Dropdown.Item>
          );
        })}
      </Dropdown>
    </div>
  );
};

export default LocaleDropdown;
